<template>
  <div class="p-0 m-0">
    <nav-bar />

    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
  </div>
</template>

<script>
import NavBar from '@components/nav-bar.vue'

export default {
  components: { NavBar },
}
</script>
